import type { ReactNode } from 'react';
import { cn } from '@newcore/ui/cn';

interface PageProps {
  children: ReactNode;
  className?: string;
}

// The column width, gutters and floating-bar clearance belong to PortalLayout,
// so every page lands on the same frame and switching pages cannot shift it.
export function Page({ children, className }: PageProps) {
  return (
    <div className={cn('flex w-full flex-col gap-12', className)}>
      {children}
    </div>
  );
}
